import { css } from '@emotion/react';
import slugify from '@sindresorhus/slugify';
import { MultiSelect } from 'components/MultiSelect';
import { IconDone } from 'components/ProcessStep';
import { Select } from 'components/Select';
import { Spinner } from 'components/Spinner';
import { useArtistsQuery, useBookerArtistsQuery } from 'generated/graphql';
import { forwardRef } from 'react';
import { theme } from 'styles/theme';

export const SelectArtists = forwardRef((params) => {
	const [{ fetching, data, error }] = useBookerArtistsQuery();

	const options = data?.bookerArtists?.map(({ id, name, url }) => {
		return { value: id, label: name, icon: null, url: url };
	});

	// const options = [];

	// console.log('OPTIONS');
	// console.log(options);

	return (
		<div>
			<MultiSelect
				isProcessing={fetching}
				options={options}
				{...params}
				placeholder="Všichni interpreti"
				sizeMedium
				renderItem={(item) => {
					return (
						<div
							css={css`
								display: flex;
								gap: 8px;
								align-items: center;
								flex-shrink: 0;
							`}
						>
							<img
								src={process.env.ASSETS_URL + 'artists/' + item.url + '.png'}
								css={css`
									border-radius: 8px;
									width: 24px;
									flex-shrink: 0;
								`}
							/>

							{item.label}
						</div>
					);
				}}
			/>
		</div>
	);
});
